import React, { useState } from "react";
import { Logo } from "./components/biat/Logo";
import { Tabs } from "./components/biat/Tabs";
import { TabPanel } from "./components/biat/TabPanel";
import { Footer } from "./components/biat/Footer";
import { TAB_CONTENT, SHORT_LINK } from "./components/biat/content";
import { ExternalLink } from "lucide-react";
import "./App.css";

function App() {
    const [active, setActive] = useState("desktop");
    const data = TAB_CONTENT[active];

    return (
        <div
            className="App bg-black text-white min-h-screen"
            data-testid="app-root"
        >
            {/* Announcement bar with short link */}
            <a
                href={SHORT_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="top-shortlink"
                className="block text-center text-xs sm:text-sm py-2.5 bg-gradient-to-r from-[#0a0a0a] via-[#1a1500] to-[#0a0a0a] border-b border-[#D4AF37]/30 text-white/85 hover:text-[#D4AF37] transition-colors"
            >
                <span className="inline-flex items-center gap-2">
                    <span className="hidden sm:inline">Güncel adresimiz:</span>
                    <span className="gold-text font-bold">
                        www.casinobiat777.com
                    </span>
                    <ExternalLink className="w-3.5 h-3.5 text-[#D4AF37]" />
                </span>
            </a>

            {/* Top brand bar */}
            <div className="py-6 flex flex-col items-center gap-4 border-b border-white/5">
                <Logo />
                <a
                    href={SHORT_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="logo-site-btn"
                    className="btn-install"
                >
                    <ExternalLink className="w-4 h-4" />
                    Siteye Git
                </a>
            </div>

            <Tabs active={active} onChange={setActive} />

            <main>
                <TabPanel data={data} tabId={active} />
            </main>

            <Footer />
        </div>
    );
}

export default App;
